import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=373a0e7b&scoped=true&"
import script from "./page-layout.vue?vue&type=script&lang=js&"
export * from "./page-layout.vue?vue&type=script&lang=js&"
import style0 from "./page-layout.vue?vue&type=style&index=0&id=373a0e7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a0e7b",
  null
  
)

export default component.exports